export default __webpack_public_path__ + "2139b532ad3a34ac3b41cc4877372cba.svg";